export default __webpack_public_path__ + "static/media/superiorPrintingLogo.535f01b2.jpg";